module.exports = __webpack_public_path__ + "img/cx.02cd6f3c.png";